<template>
  <div style="width: 95%;">
    <b-row>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Nombre establecimiento">
            <b-form-input data-vv-scope="alta" v-validate="'required'" name="Nombre establecimiento"
                          v-model="detalles.nombre" :disabled="!hasPermision('E')"></b-form-input>
            <span class="error">{{ errors.first('alta.Nombre establecimiento') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Categoria GN">
            <b-form-select data-vv-scope="alta" v-validate="{ is_not: 1 , required:true}" name="Categoria GN"
                           @input="loadTipo(false)" v-model="detalles['id_categoria_gn_'+type].id"
                           :options="categoria_gn_options" class="mb-3" :text-field="'categoria_gn_'+type"
                           value-field="id" :disabled="!hasPermision('E')"/>
            <span class="error">{{ errors.first('alta.Categoria GN') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Tipo establecimiento">
            <!-- <b-form-select data-vv-scope="alta" v-validate="'required'" name="Tipo establecimiento" text-field="tipo" value-field="id"
              v-model="detalles['id_tipo_establecimiento_gn_'+type].id" :options="tipo_establecimiento_gn_options"
              class="mb-3" :disabled="tipo_establecimiento_gn_options.length===0 || !hasPermision('E')"
            /> -->

            <multiselect
              placeholder="Seleccionar una opción"
              selectedLabel="Seleccionada"
              deselect-label="Click o enter para deseleccionar"
              select-label="Click o enter para seleccionar"
              tag-placeholder="Seleccionar"
              v-model="detalles['id_tipo_establecimiento_gn_'+type]"
              :options="tipo_establecimiento_gn_options"
              label="tipo" track-by="id"
              @close='closedTipoEstablecimiento'
              :disabled="tipo_establecimiento_gn_options.length===0 || !hasPermision('E')"
            >
            </multiselect>

            <span class="error">{{ customErrors['tipo_establecimiento'] }}</span>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Código CNAE">
            <!-- <b-form-select v-model="detalles.codigo_cnae" :options="cnae_options" class="mb-3" text-field="descripcion" value-field="id" :disabled="!hasPermision('E')"/> -->

            <multiselect
              placeholder="Seleccionar una opción"
              selectedLabel="Seleccionada"
              deselect-label="Click o enter para deseleccionar"
              select-label="Click o enter para seleccionar"
              tag-placeholder="Seleccionar"
              :custom-label="customLabelCNAE"
              v-model="detalles.codigo_cnae"
              :options="cnae_options"
              label="descripcion" track-by="id"
              :disabled="!hasPermision('E')">
            </multiselect>

          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Provincia">
            <b-form-select data-vv-scope="alta" v-validate="'required'" name="Provincia" @input="loadMunicipio()"
                           v-model="detalles.codigo_provincia_zeus" :options="provincias_options" class="mb-3"
                           text-field="entity_name" value-field="id" :disabled="!hasPermision('E')"/>
            <span class="error">{{ errors.first('alta.Provincia') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Municipio">
            <b-form-select data-vv-scope="alta" v-validate="'required'" name="Municipio" @input="loadPoblacion()"
                           text-field="entity_name" value-field="id" v-model="detalles.codigo_municipio_zeus"
                           :options="municipio_options" class="mb-3"
                           :disabled="municipio_options.length===0 || !hasPermision('E')"/>
            <span class="error">{{ errors.first('alta.Municipio') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Población">
            <b-form-select data-vv-scope="alta" v-validate="'required'" name="Población" text-field="entity_name"
                           value-field="id" v-model="detalles.codigo_poblacion_zeus" :options="poblacion_options"
                           class="mb-3" :disabled="poblacion_options.length===0 || !hasPermision('E')"/>
            <span class="error">{{ errors.first('alta.Población') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Tipo vía">
            <b-form-select data-vv-scope="alta" v-validate="direccionValidate" name="Tipo vía"
                           v-model="detalles.tipo_via" :options="tipo_via_options" class="mb-3" text-field="name_type"
                           value-field="name_type" :disabled="!hasPermision('E')"/>
            <span class="error">{{ errors.first('alta.Tipo vía') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Nombre vía" class="autocomplete">
            <b-form-input autocomplete="off" @input="loadNames" data-vv-scope="alta" v-validate="direccionValidate"
                          name="Nombre vía" v-model="detalles.nombre_via" :disabled="!hasPermision('E')"></b-form-input>
            <div v-if="show_names" class="autocomplete-items">
              <div @click="setElement(element)" v-for="(element, index) in names_suggestions" v-bind:key="index">
                {{ element.street_type.name_type }} {{ element.street_name }} ({{ element.postal_code_address }})
                <!-- <strong>Sp</strong>ain<input type="hidden" value="Spain"> -->
              </div>
            </div>
            <span class="error">{{ errors.first('alta.Nombre vía') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Número">
            <b-form-input data-vv-scope="alta" v-validate="direccionValidate" name="Número" v-model="detalles.numero"
                          :disabled="!hasPermision('E')"></b-form-input>
            <span class="error">{{ errors.first('alta.Número') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Anexo">
            <b-form-input v-model="detalles.anexo" :disabled="!hasPermision('E')"></b-form-input>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Dirección no estructurada">
            <b-form-input data-vv-scope="alta" v-validate="direccionValidate" name="Dirección no estructurada"
                          v-model="detalles.direccion_no_estructurada" :disabled="!hasPermision('E')"></b-form-input>
            <span class="error">{{ errors.first('alta.Dirección no estructurada') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Código postal">
            <b-form-input data-vv-scope="alta" v-validate="'required|cod_postal'" name='Código postal'
                          v-model="detalles.codigo_postal" :disabled="!hasPermision('E')"></b-form-input>
            <span class="error">{{ errors.first('alta.Código postal') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Latitud">
            <b-form-input data-vv-scope="alta" v-validate="'required'" name="Latitud"
                          v-model="detalles.latitud_original" :disabled="!hasPermision('E')"></b-form-input>
            <span class="error">{{ errors.first('alta.Latitud') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Longitud">
            <b-form-input data-vv-scope="alta" v-validate="'required'" name="Longitud"
                          v-model="detalles.longitud_original" :disabled="!hasPermision('E')"></b-form-input>
            <span class="error">{{ errors.first('alta.Longitud') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col>
        <b-form>
          <b-form-group style="font-size: 1rem;" label="Precisión coordenadas">
            <b-form-select data-vv-scope="alta" v-validate="'required'" name="Precisión coordenadas"
                           v-model="detalles.id_precision_coordenada.id" :options="coordenadas_options" class="mb-3"
                           text-field="tipo_precision" value-field="id" :disabled="!hasPermision('E')"/>
            <span class="error">{{ errors.first('alta.Precisión coordenadas') }}</span>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="text-align: right;" v-if="hasPermision('E')">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button @click="emitSave">Guardar</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<style>
.autocomplete {
  /*the container must be positioned relative:*/
  position: relative;
  /* display: inline-block; */
}

.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
}

.autocomplete-items div {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #d4d4d4;
}

.autocomplete-items div:hover {
  /*when hovering an item:*/
  background-color: #e9e9e9;
}

.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff;
}
</style>

<script>
import Loader from '@/components/Layout/Loader.vue';

import {Validator} from 'vee-validate';

var debounce = require('debounce');
export default {
  name: 'NewComercial',
  inject: {
    $validator: '$validator'
  },
  props: ['feature', 'type', 'permisos'],
  components: {
    Loader
  },
  data () {
    return {
      customErrors: {
        'tipo_establecimiento': null
      },
      detalles: {
        id_categoria_gn_comercial: {},
        id_categoria_gn_caldera: {},
        id_precision_coordenada: {}
      },
      options: [],
      provincias_options: [],
      categoria_gn_options: [],
      tipo_via_options: [],
      coordenadas_options: [],
      cnae_options: [],
      municipio_options: [],
      poblacion_options: [],
      tipo_establecimiento_gn_options: [],
      show_names: false,
      clickHappened: false,
      loading: 0
    };
  },
  created () {
    let th = this;
    Validator.extend('cod_postal', {
      getMessage (field, args) {
        return 'El código postal introducido no es válido.';
      },
      validate (value, args) {
        let regex = /^((0[1-9]|5[0-2])|[1-4][0-9])[0-9]{3}$/;

        // debugger
        let prov = th.detalles.codigo_provincia_zeus;
        // console.log(prov)

        // console.log(prov)
        return (regex.test(value) && value.indexOf(prov) === 0);
      }
    });
  },
  mounted: function () {
    this.detalles = this.feature.properties;
    Promise.all([
      this.$http.get('geoprovincia/', {params: {not_paginated: true}}),
      // this.$http.get('municipios/', {params: {not_paginated: true}}),
      // this.$http.get('poblaciones/', {params: {not_paginated: true}}),
      this.$http.get('categorias_gn_' + this.type + '/', {params: {not_paginated: true}}),
      this.$http.get('tipos_vias/', {params: {not_paginated: true}}),
      this.$http.get('precision_coordenadas/', {params: {not_paginated: true}}),
      this.$http.get('cnae/', {params: {not_paginated: true}})
    ]).then(results => {
      this.provincias_options = [{id: null, entity_name: ''}].concat(results[0].data);
      this.categoria_gn_options = [{id: null, categoria_gn_comercial: ''}].concat(results[1].data);
      this.tipo_via_options = [{id: null, name_type: ''}].concat(results[2].data);
      this.coordenadas_options = [{id: null, tipo_precision: ''}].concat(results[3].data);

      this.cnae_options = [{id: null, descripcion: ''}].concat(results[4].data);
      // this.cnae_options = this.cnae_options.map(function (e) {
      //   e.descripcion = e.id + ' - ' + e.descripcion
      //   return e
      // })

      // this.cnae_options = [{id: null, descripcion: ''}].concat(results[4].data).map(e => e.id + ' - ' + e.descripcion)
      this.categoria_gn_options.map(v => {
        if (v.categoria_gn_comercial === 'CLIENTES COMERCIALES') {
          v.disabled = true;
        }
        return v;
      });
    });
  },
  computed: {
    direccionValidate: function () {
      var value = this.detalles.direccion_no_estructurada || (this.detalles.tipo_via && this.detalles.nombre_via && this.detalles.numero);
      return {required: !value};
    }
  },
  methods: {

    customLabelCNAE: function (opt) {
      return opt.id + ' - ' + opt.descripcion;
    },
    closedTipoEstablecimiento: function (val, id) {
      this.validTipoEstablecimiento();
    },
    validTipoEstablecimiento: function () {
      if (this.detalles['id_tipo_establecimiento_gn_' + this.type] !== undefined && this.detalles['id_tipo_establecimiento_gn_' + this.type] !== null && this.detalles['id_tipo_establecimiento_gn_' + this.type].id !== undefined && this.detalles['id_tipo_establecimiento_gn_' + this.type].id !== null) {
        this.customErrors['tipo_establecimiento'] = null;
        return true;
      }
      this.customErrors['tipo_establecimiento'] = 'El campo Tipo establecimiento es obligatorio.';
      return false;
    },
    loadNames: debounce(function (value) {
      if (value && !this.clickHappened && this.detalles.codigo_municipio_zeus) {
        var municipio = this.municipio_options.find(e => e.id === this.detalles.codigo_municipio_zeus).zeus_codigo_municipio_ine;
        this.$http.get('streets/', {
          params: {
            zeus_codigo_municipio_ine: municipio,
            direccion__icontains: value.toUpperCase()
          }
        }).then(result => {
          this.names_suggestions = result.data.results;
          // this.names_suggestions_list = result.data.results
          // for (let index = 0; index < this.names_suggestions_list.length; index++) {
          //   const element = this.names_suggestions_list[index]
          //   if (element.street_name.substr(0, value.length).toUpperCase() === value.toUpperCase()) {
          //     this.names_suggestions.push(element)
          //   }
          // }
          this.show_names = true;
        });
      } else {
        this.show_names = false;
      }
    }, 250),

    setElement: function (value) {
      if (value.street_name) {
        this.$set(this.detalles, 'nombre_via', value.street_name);
      }
      if (value.postal_code_address) {
        this.$set(this.detalles, 'codigo_postal', value.postal_code_address);
      }
      if (value.street_type) {
        this.$set(this.detalles, 'tipo_via', value.street_type.name_type);
      }
      if (value.zeus_codigo_poblacion_ine) {
        var p = this.poblacion_options.find(e => e.zeus_codigo_poblacion_ine === value.zeus_codigo_poblacion_ine);
        if (p) {
          this.$set(this.detalles, 'codigo_poblacion_zeus', p.id);
        } else {
          this.$set(this.detalles, 'codigo_poblacion_zeus', null);
        }
      }

      this.show_names = false;
      this.clickHappened = true;

      var th = this;
      setTimeout(() => {
        th.clickHappened = false;
      }, 400);
    },
    loadTipo: function () {
      if (this.detalles['id_categoria_gn_' + this.type] && this.detalles['id_categoria_gn_' + this.type].id) {
        var params = {params: {not_paginated: true}};
        if (this.type === 'comercial') {
          params = {
            params: {
              not_paginated: true,
              ['id_categoria_gn_' + this.type]: this.detalles['id_categoria_gn_' + this.type].id
            }
          };
        }
        this.$http.get('tipos_' + this.type + '/', params).then(result => {
          this.tipo_establecimiento_gn_options = [{id: null, tipo: ''}].concat(result.data);
          this.loading = this.loading - 1;
        });
      } else {
        this.tipo_establecimiento_gn_options = [];
        this.loading = this.loading - 1;
      }
    },
    loadMunicipio: function () {
      if (this.detalles.codigo_provincia_zeus) {
        this.$http.get('geomunicipio/', {
          params: {
            not_paginated: true,
            cod_gas_provincia: this.detalles.codigo_provincia_zeus
          }
        }).then(result => {
          this.municipio_options = [{id: null, entity_name: ''}].concat(result.data);
          this.loading = this.loading - 1;
        });
        this.detalles.codigo_postal = null;
      } else {
        this.municipio_options = [];
        this.loading = this.loading - 1;
      }
    },
    loadPoblacion: function () {
      if (this.detalles.codigo_municipio_zeus) {
        this.$http.get('geopoblacion/', {
          params: {
            not_paginated: true,
            cod_gas_municipio: this.detalles.codigo_municipio_zeus
          }
        }).then(result => {
          this.poblacion_options = [{id: null, entity_name: ''}].concat(result.data);
          this.loading = this.loading - 1;
        });
      } else {
        this.poblacion_options = [];
        this.loading = this.loading - 1;
      }
    },
    cancel: function () {
      this.$emit('close');
    },
    emitSave: function () {
      this.$emit('save');
    },
    save: function () {
      // this.$validator.validate().then(result => {
      // if (!result) {
      //   alert('Tienes algún error en el formulario')
      // } else {
      this.loading = 1;
      if (this.detalles.codigo_provincia_zeus) {
        this.detalles.provincia = this.provincias_options.find(e => e.id === this.detalles.codigo_provincia_zeus).entity_name;
      } else {
        this.detalles.provincia = '';
      }
      if (this.detalles.codigo_municipio_zeus) {
        this.detalles.municipio = this.municipio_options.find(e => e.id === this.detalles.codigo_municipio_zeus).entity_name;
      } else {
        this.detalles.municipio = '';
      }
      if (this.detalles.codigo_poblacion_zeus) {
        this.detalles.poblacion = this.poblacion_options.find(e => e.id === this.detalles.codigo_poblacion_zeus).entity_name;
      } else {
        this.detalles.poblacion = '';
      }

      return this.detalles;
      //   }
      // })

      //   this.$validator.validate().then(result => {
      //     if (!result) {
      //       alert('Tienes algún error en el formulario')
      //     } else {
      //       this.loading = 1
      //       if (this.detalles.codigo_provincia_zeus) {
      //         this.detalles.provincia = this.provincias_options.find(e => e.id === this.detalles.codigo_provincia_zeus).entity_name
      //       } else {
      //         this.detalles.provincia = ''
      //       }
      //       if (this.detalles.codigo_municipio_zeus) {
      //         this.detalles.municipio = this.municipio_options.find(e => e.id === this.detalles.codigo_municipio_zeus).entity_name
      //       } else {
      //         this.detalles.municipio = ''
      //       }
      //       if (this.detalles.codigo_poblacion_zeus) {
      //         this.detalles.poblacion = this.poblacion_options.find(e => e.id === this.detalles.codigo_poblacion_zeus).entity_name
      //       } else {
      //         this.detalles.poblacion = ''
      //       }

      //       return this.detalles
      //     }
      //   })
    },
    hasPermision: function (p) {
      var rol = '';
      if (this.type === 'caldera') {
        rol = 'CALDERA CENTRALIZADA';
      } else {
        rol = 'COMERCIAL';
      }
      return this.permisos[rol][p];
    }
  },
  watch: {
    feature: function () {
      this.detalles = this.feature.properties;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/Details/new_comercial.vue